// Which edit control a family_context fact gets in Family Profile.
//
// Pure, and in its own module so it can be asserted: FamilyProfileSection.tsx
// imports the supabase client at module scope, which vitest does not load the
// way dev/build do — the same reason familyPrefillFacts.ts lives apart from
// useFamilyPrefill.ts.

/**
 * Keys whose values are prose, not a token. They arrive from chat, voice and
 * the Babysitter care sheet as sentences, and are routinely long enough that a
 * single-line input shows roughly thirty characters of a three-hundred
 * character value and scrolls horizontally to reach the rest.
 */
export const MULTILINE_FACT_KEYS = new Set([
  "bedtime_routine",
  "meals_snacks",
  "medications",
  "kid_notes",
  "emergency_contacts",
  "house_rules",
]);

/** Values longer than this get a textarea whatever their key. */
export const LONG_VALUE_CHARS = 80;

/**
 * Long or prose-shaped values get a textarea; short single-line facts (a name,
 * a diaper size, a date) keep the input. Making every field a textarea would
 * put a multi-line box around "Emma", which reads as broken.
 *
 * The length test runs against the CURRENT draft, so a fact that grows past
 * the threshold while she is typing gets the better control immediately, and
 * one that has grown long since it was written gets it on the next open
 * without anyone having to add its key to the set above.
 */
export function usesTextarea(key: string, value: string): boolean {
  // birthdate stays a native date picker — a textarea there would be worse.
  if (key === "birthdate") return false;
  if (MULTILINE_FACT_KEYS.has(key)) return true;
  return (value ?? "").length > LONG_VALUE_CHARS;
}
